const reducerName = '@cityoo-backoffice/territories/counties';

export const RESET = `${reducerName}/RESET`;

export const GET_COUNTIES_START = `${reducerName}/GET_COUNTIES_START`;
export const GET_COUNTIES_SUCCESS = `${reducerName}/GET_COUNTIES_SUCCESS`;
export const GET_COUNTIES_FAIL = `${reducerName}/GET_COUNTIES_FAIL`;
